import React, { Component } from 'react';  
import { Route } from 'react-router-dom';  

  
const BareLayoutRoute = ({component: Component, ...rest}) => {  
  return (  
    <Route {...rest} render={matchProps => (  
          <Component {...matchProps} />  
    )} />  
  )  
};  

export default BareLayoutRoute;